export default __webpack_public_path__ + "static/media/weth.4101f1da.png";